import * as React from 'react';
import { connect } from 'react-redux';
import AppActions from '../../app/app_actions';
import { Utils, NumberFormatter, DateFormatter } from 'arm-common';
import * as agui from 'arm-gui/dist/controls';
import ImpostazioniActions from './impostazioni_actions';
import { AppConstants } from '../../constants/AppConstants';

class ImpostazioniParametri extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = '[ImpostazioniParametri.jsx] ';
    }


    componentDidMount() {
        console.log(this.componentName + ' componentDidMount');

        //definisco le colonne della boostrap table
        let columns = [
            { field: 'id.cpar', title: 'Nome', sortable: 'true' },
            { field: 'id.camb', title: 'Sistema', sortable: 'true' },
            { field: 'zpar', title: 'Valore', sortable: 'true' },
            { field: 'zdes', title: 'Descrizione', sortable: 'true' },
            { field: 'cdip', title: 'Par', sortable: 'true' },
            { field: 'tpar', title: 'Tipo', sortable: 'true' },

        ];



        $(this.refs.MyTable).bootstrapTable({
            columns: columns,
            idField: "id.camb",
            sortable: true,
            search: true,
            showColumns: true,
            showExport: true,
            exportDataType: 'all',
            exportTypes: ['csv', 'excel'],

            sortOrder: "desc",
            pagination: true,


        });

        //effettuo la chimata rest per recuperare i dati
        this.props.getListParametriSistema();
    }




    componentWillReceiveProps(nextProps) {
        console.log(this.componentName + ' componentWillReceiveProps');

        if (nextProps.rows !== this.props.rows) {
            console.log("\t rows: " + (nextProps.rows !== null ? nextProps.rows.length : "NULL"));

            $(this.refs.MyTable).bootstrapTable('load', nextProps.rows);
        }
    }

    render() {
        console.log(this.componentName + ' render');
        return (
            <agui.aCardV4>
                <agui.aCardV4Header>
                    <h3>Lista Parametri</h3>
                </agui.aCardV4Header>
                <agui.aCardV4Body>
                    <table ref="MyTable" className={AppConstants.CLASS_TABLE} />

                </agui.aCardV4Body>
            </agui.aCardV4>
        );
    }
};

function mapDispatchToProps(dispatch) {
    return {
        getListParametriSistema() {
            return dispatch(ImpostazioniActions.getParametriSistema());
        }
    }
};

function mapStateToProps(state) {
    return {
        rows: state.impostazioni.listParametriSistema
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(ImpostazioniParametri);
